const state = {
  karteData: {
    features: [
      {
        BLOOD_PRESSURE: {
          BP_HIGH: null,
          BP_LWST: null,
        },
        BLOOD_TEST: {
          BLDS: null,
          HBA1C: null,
          CREATININE: null,
          GAMMA_GTP: null,
          HDL_CHOLE: null,
          HMG: null,
          LDL_CHOLE: null,
          SGOT_AST: null,
          SGPT_ALT: null,
          TOT_CHOLE: null,
          TRIGLYCERIDE: null,
          WHITE_BLC: null,
          RED_BLC: null,
          PLT_CNT: null,
          HEMATOCRIT: null,
        },
        DRINK: {
          DRNK_HABIT_RSPS_CD: null,
          TM1_DRKQTY_RSPS_CD: null,
          DRNK_QTY_WEK_CD: null,
        },
        EXERCISE: {
          MOV20_WEK_FREQ_ID: null,
          MOV30_WEK_FREQ_ID: null,
          WLK30_WEK_FREQ_ID: null,
        },
        FAMILY_HISTORY: {
          FMLY_APOP_PATIEN_YN: false,
          FMLY_CANCER_PATIEN_YN: false,
          FMLY_DIABML_PATIEN_YN: false,
          FMLY_HDISE_PATIEN_YN: false,
          FMLY_HPRTS_PATIEN_YN: false,
        },
        PAST_HISTORY: {
          HCHK_APOP_PMH_YN: false,
          HCHK_DIABML_PMH_YN: false,
          HCHK_ETCDSE_PMH_YN: false,
          HCHK_HDISE_PMH_YN: false,
          HCHK_HPLPDM_PMH_YN: false,
          HCHK_HPRTS_PMH_YN: false,
          HCHK_PHSS_PMH_YN: false,
        },
        GENERAL: {
          AGE: null,
          DFAB_PTN_CD: null,
          SEX: 1,
          T: null,
        },
        MEASURE: {
          BMI: null,
          WAIST: null,
          WEIGHT: null,
          ELECTROCARDIOGRAPHY: 1,
          SPUTUM_EXAMINATION: 1,
          HEARING_LOW_LEFT: null,
          HEARING_LOW_RIGHT: null,
          HEARING_HIGH_LEFT: null,
          HEARING_HIGH_RIGHT: null,
          WITHOUT_GLASSES_LEFT: null,
          WITHOUT_GLASSES_RIGHT: null,
          WITH_GLASSES_LEFT: null,
          WITH_GLASSES_RIGHT: null,
        },
        SMOKE: {
          SMK_STAT_TYPE_RSPS_CD: 1,
          PAST_DSQTY_RSPS_CD: null,
          PAST_SMK_TERM_RSPS_CD: null,
          CUR_DSQTY_RSPS_CD: null,
          CUR_SMK_TERM_RSPS_CD: null,
        },
        URINE_TEST: {
          OLIG_PROTE_CD: 0,
          URIC_ACID: null,
          URIC_SUGAR: null,
        },
      },
    ],
    name: null,
    model: {
      DM: false,
      LIVER: false,
      BREAST: false,
      DEMENTIA: false,
      HEART: false,
      STOMACH: false,
      COLORECTAL: false,
      LUNG: false,
      STROKE: false,
      PROSTATE: false,
    },
  },
};

const mutations = {
  setNAME(state, payload) {
    state.karteData.name = payload;
  },
  setBP_HIGH(state, payload) {
    state.karteData.features[0].BLOOD_PRESSURE.BP_HIGH = payload;
  },
  setBP_LWST(state, payload) {
    state.karteData.features[0].BLOOD_PRESSURE.BP_LWST = payload;
  },
  setBLDS(state, payload) {
    state.karteData.features[0].BLOOD_TEST.BLDS = payload;
  },
  setCREATININE(state, payload) {
    state.karteData.features[0].BLOOD_TEST.CREATININE = payload;
  },
  setGAMMA_GTP(state, payload) {
    state.karteData.features[0].BLOOD_TEST.GAMMA_GTP = payload;
  },
  setHDL_CHOLE(state, payload) {
    state.karteData.features[0].BLOOD_TEST.HDL_CHOLE = payload;
  },
  setHMG(state, payload) {
    state.karteData.features[0].BLOOD_TEST.HMG = payload;
  },
  setLDL_CHOLE(state, payload) {
    state.karteData.features[0].BLOOD_TEST.LDL_CHOLE = payload;
  },
  setSGOT_AST(state, payload) {
    state.karteData.features[0].BLOOD_TEST.SGOT_AST = payload;
  },
  setSGPT_ALT(state, payload) {
    state.karteData.features[0].BLOOD_TEST.SGPT_ALT = payload;
  },
  setTOT_CHOLE(state, payload) {
    state.karteData.features[0].BLOOD_TEST.TOT_CHOLE = payload;
  },
  setTRIGLYCERIDE(state, payload) {
    state.karteData.features[0].BLOOD_TEST.TRIGLYCERIDE = payload;
  },
  setDRNK_HABIT_RSPS_CD(state, payload) {
    state.karteData.features[0].DRINK.DRNK_HABIT_RSPS_CD = payload;
  },
  setTM1_DRKQTY_RSPS_CD(state, payload) {
    state.karteData.features[0].DRINK.TM1_DRKQTY_RSPS_CD = payload;
  },
  setDRNK_QTY_WEK_CD(state, payload) {
    state.karteData.features[0].DRINK.DRNK_QTY_WEK_CD = payload;
  },
  setMOV20_WEK_FREQ_ID(state, payload) {
    state.karteData.features[0].EXERCISE.MOV20_WEK_FREQ_ID = payload;
  },
  setMOV30_WEK_FREQ_ID(state, payload) {
    state.karteData.features[0].EXERCISE.MOV30_WEK_FREQ_ID = payload;
  },
  setWLK30_WEK_FREQ_ID(state, payload) {
    state.karteData.features[0].EXERCISE.WLK30_WEK_FREQ_ID = payload;
  },
  setFMLY_APOP_PATIEN_YN(state, payload) {
    state.karteData.features[0].FAMILY_HISTORY.FMLY_APOP_PATIEN_YN = payload;
  },
  setFMLY_CANCER_PATIEN_YN(state, payload) {
    state.karteData.features[0].FAMILY_HISTORY.FMLY_CANCER_PATIEN_YN = payload;
  },
  setFMLY_DIABML_PATIEN_YN(state, payload) {
    state.karteData.features[0].FAMILY_HISTORY.FMLY_DIABML_PATIEN_YN = payload;
  },
  setFMLY_HDISE_PATIEN_YN(state, payload) {
    state.karteData.features[0].FAMILY_HISTORY.FMLY_HDISE_PATIEN_YN = payload;
  },
  setFMLY_HPRTS_PATIEN_YN(state, payload) {
    state.karteData.features[0].FAMILY_HISTORY.FMLY_HPRTS_PATIEN_YN = payload;
  },
  setAGE(state, payload) {
    state.karteData.features[0].GENERAL.AGE = payload;
  },
  setDFAB_PTN_CD(state, payload) {
    state.karteData.features[0].GENERAL.DFAB_PTN_CD = payload;
  },
  setSEX(state, payload) {
    state.karteData.features[0].GENERAL.SEX = payload;
  },
  setT(state, payload) {
    state.karteData.features[0].GENERAL.T = payload;
  },
  setBMI(state, payload) {
    state.karteData.features[0].MEASURE.BMI = payload;
  },
  setWAIST(state, payload) {
    state.karteData.features[0].MEASURE.WAIST = payload;
  },
  setSMK_STAT_TYPE_RSPS_CD(state, payload) {
    state.karteData.features[0].SMOKE.SMK_STAT_TYPE_RSPS_CD = payload;
  },
  setPAST_DSQTY_RSPS_CD(state, payload) {
    state.karteData.features[0].SMOKE.PAST_DSQTY_RSPS_CD = payload;
  },
  setPAST_SMK_TERM_RSPS_CD(state, payload) {
    state.karteData.features[0].SMOKE.PAST_SMK_TERM_RSPS_CD = payload;
  },
  setCUR_DSQTY_RSPS_CD(state, payload) {
    state.karteData.features[0].SMOKE.CUR_DSQTY_RSPS_CD = payload;
  },
  setCUR_SMK_TERM_RSPS_CD(state, payload) {
    state.karteData.features[0].SMOKE.CUR_SMK_TERM_RSPS_CD = payload;
  },
  setOLIG_PROTE_CD(state, payload) {
    state.karteData.features[0].URINE_TEST.OLIG_PROTE_CD = payload;
  },
  setHCHK_APOP_PMH_YN(state, payload) {
    state.karteData.features[0].PAST_HISTORY.HCHK_APOP_PMH_YN = payload;
  },
  setHCHK_DIABML_PMH_YN(state, payload) {
    state.karteData.features[0].PAST_HISTORY.HCHK_DIABML_PMH_YN = payload;
  },
  setHCHK_ETCDSE_PMH_YN(state, payload) {
    state.karteData.features[0].PAST_HISTORY.HCHK_ETCDSE_PMH_YN = payload;
  },
  setHCHK_HDISE_PMH_YN(state, payload) {
    state.karteData.features[0].PAST_HISTORY.HCHK_HDISE_PMH_YN = payload;
  },
  setHCHK_HPLPDM_PMH_YN(state, payload) {
    state.karteData.features[0].PAST_HISTORY.HCHK_HPLPDM_PMH_YN = payload;
  },
  setHCHK_HPRTS_PMH_YN(state, payload) {
    state.karteData.features[0].PAST_HISTORY.HCHK_HPRTS_PMH_YN = payload;
  },
  setHCHK_PHSS_PMH_YN(state, payload) {
    state.karteData.features[0].PAST_HISTORY.HCHK_PHSS_PMH_YN = payload;
  },
  setModel(state, payload) {
    state.karteData.model = payload;
  },
  setWEIGHT(state, payload) {
    state.karteData.features[0].MEASURE.WEIGHT = payload;
  },
  setELECTROCARDIOGRAPHY(state, payload) {
    state.karteData.features[0].MEASURE.ELECTROCARDIOGRAPHY = payload;
  },
  setSPUTUM_EXAMINATION(state, payload) {
    state.karteData.features[0].MEASURE.SPUTUM_EXAMINATION = payload;
  },
  setHEARING_LOW_LEFT(state, payload) {
    state.karteData.features[0].MEASURE.HEARING_LOW_LEFT = payload;
  },
  setHEARING_LOW_RIGHT(state, payload) {
    state.karteData.features[0].MEASURE.HEARING_LOW_RIGHT = payload;
  },
  setHEARING_HIGH_LEFT(state, payload) {
    state.karteData.features[0].MEASURE.HEARING_HIGH_LEFT = payload;
  },
  setHEARING_HIGH_RIGHT(state, payload) {
    state.karteData.features[0].MEASURE.HEARING_HIGH_RIGHT = payload;
  },
  setWITHOUT_GLASSES_LEFT(state, payload) {
    state.karteData.features[0].MEASURE.WITHOUT_GLASSES_LEFT = payload;
  },
  setWITHOUT_GLASSES_RIGHT(state, payload) {
    state.karteData.features[0].MEASURE.WITHOUT_GLASSES_RIGHT = payload;
  },
  setWITH_GLASSES_LEFT(state, payload) {
    state.karteData.features[0].MEASURE.WITH_GLASSES_LEFT = payload;
  },
  setWITH_GLASSES_RIGHT(state, payload) {
    state.karteData.features[0].MEASURE.WITH_GLASSES_RIGHT = payload;
  },
  setHBA1C(state, payload) {
    state.karteData.features[0].BLOOD_TEST.HBA1C = payload;
  },
  setWHITE_BLC(state, payload) {
    state.karteData.features[0].BLOOD_TEST.WHITE_BLC = payload;
  },
  setRED_BLC(state, payload) {
    state.karteData.features[0].BLOOD_TEST.RED_BLC = payload;
  },
  setPLT_CNT(state, payload) {
    state.karteData.features[0].BLOOD_TEST.PLT_CNT = payload;
  },
  setHEMATOCRIT(state, payload) {
    state.karteData.features[0].BLOOD_TEST.HEMATOCRIT = payload;
  },
  setURIC_ACID(state, payload) {
    state.karteData.features[0].URINE_TEST.URIC_ACID = payload;
  },
  setURIC_SUGAR(state, payload) {
    state.karteData.features[0].URINE_TEST.URIC_SUGAR = payload;
  },
};

const actions = {
  setNAME({ commit }, payload) {
    commit("setNAME", payload);
  },
  setBP_HIGH({ commit }, payload) {
    commit("setBP_HIGH", payload);
  },
  setBP_LWST({ commit }, payload) {
    commit("setBP_LWST", payload);
  },
  setBLDS({ commit }, payload) {
    commit("setBLDS", payload);
  },
  setCREATININE({ commit }, payload) {
    commit("setCREATININE", payload);
  },
  setGAMMA_GTP({ commit }, payload) {
    commit("setGAMMA_GTP", payload);
  },
  setHDL_CHOLE({ commit }, payload) {
    commit("setHDL_CHOLE", payload);
  },
  setHMG({ commit }, payload) {
    commit("setHMG", payload);
  },
  setLDL_CHOLE({ commit }, payload) {
    commit("setLDL_CHOLE", payload);
  },
  setSGOT_AST({ commit }, payload) {
    commit("setSGOT_AST", payload);
  },
  setSGPT_ALT({ commit }, payload) {
    commit("setSGPT_ALT", payload);
  },
  setTOT_CHOLE({ commit }, payload) {
    commit("setTOT_CHOLE", payload);
  },
  setTRIGLYCERIDE({ commit }, payload) {
    commit("setTRIGLYCERIDE", payload);
  },
  setDRNK_HABIT_RSPS_CD({ commit }, payload) {
    commit("setDRNK_HABIT_RSPS_CD", payload);
  },
  setTM1_DRKQTY_RSPS_CD({ commit }, payload) {
    commit("setTM1_DRKQTY_RSPS_CD", payload);
  },
  setDRNK_QTY_WEK_CD({ commit }, payload) {
    commit("setDRNK_QTY_WEK_CD", payload);
  },
  setMOV20_WEK_FREQ_ID({ commit }, payload) {
    commit("setMOV20_WEK_FREQ_ID", payload);
  },
  setMOV30_WEK_FREQ_ID({ commit }, payload) {
    commit("setMOV30_WEK_FREQ_ID", payload);
  },
  setWLK30_WEK_FREQ_ID({ commit }, payload) {
    commit("setWLK30_WEK_FREQ_ID", payload);
  },
  setFMLY_APOP_PATIEN_YN({ commit }, payload) {
    commit("setFMLY_APOP_PATIEN_YN", payload);
  },
  setFMLY_DIABML_PATIEN_YN({ commit }, payload) {
    commit("setFMLY_DIABML_PATIEN_YN", payload);
  },
  setFMLY_CANCER_PATIEN_YN({ commit }, payload) {
    commit("setFMLY_CANCER_PATIEN_YN", payload);
  },
  setFMLY_HDISE_PATIEN_YN({ commit }, payload) {
    commit("setFMLY_HDISE_PATIEN_YN", payload);
  },
  setFMLY_HPRTS_PATIEN_YN({ commit }, payload) {
    commit("setFMLY_HPRTS_PATIEN_YN", payload);
  },
  setAGE({ commit }, payload) {
    commit("setAGE", payload);
  },
  setDFAB_PTN_CD({ commit }, payload) {
    commit("setDFAB_PTN_CD", payload);
  },
  setSEX({ commit }, payload) {
    commit("setSEX", payload);
  },
  setT({ commit }, payload) {
    commit("setT", payload);
  },
  setBMI({ commit }, payload) {
    commit("setBMI", payload);
  },
  setWAIST({ commit }, payload) {
    commit("setWAIST", payload);
  },
  setSMK_STAT_TYPE_RSPS_CD({ commit }, payload) {
    commit("setSMK_STAT_TYPE_RSPS_CD", payload);
  },
  setPAST_DSQTY_RSPS_CD({ commit }, payload) {
    commit("setPAST_DSQTY_RSPS_CD", payload);
  },
  setPAST_SMK_TERM_RSPS_CD({ commit }, payload) {
    commit("setPAST_SMK_TERM_RSPS_CD", payload);
  },
  setCUR_DSQTY_RSPS_CD({ commit }, payload) {
    commit("setCUR_DSQTY_RSPS_CD", payload);
  },
  setCUR_SMK_TERM_RSPS_CD({ commit }, payload) {
    commit("setCUR_SMK_TERM_RSPS_CD", payload);
  },
  setOLIG_PROTE_CD({ commit }, payload) {
    commit("setOLIG_PROTE_CD", payload);
  },
  setHCHK_APOP_PMH_YN({ commit }, payload) {
    commit("setHCHK_APOP_PMH_YN", payload);
  },
  setHCHK_DIABML_PMH_YN({ commit }, payload) {
    commit("setHCHK_DIABML_PMH_YN", payload);
  },
  setHCHK_ETCDSE_PMH_YN({ commit }, payload) {
    commit("setHCHK_ETCDSE_PMH_YN", payload);
  },
  setHCHK_HDISE_PMH_YN({ commit }, payload) {
    commit("setHCHK_HDISE_PMH_YN", payload);
  },
  setHCHK_HPLPDM_PMH_YN({ commit }, payload) {
    commit("setHCHK_HPLPDM_PMH_YN", payload);
  },
  setHCHK_HPRTS_PMH_YN({ commit }, payload) {
    commit("setHCHK_HPRTS_PMH_YN", payload);
  },
  setHCHK_PHSS_PMH_YN({ commit }, payload) {
    commit("setHCHK_PHSS_PMH_YN", payload);
  },
  setModel({ commit }, payload) {
    commit("setModel", payload);
  },
  // 新規追加項目 健康診断項目 ↓ 12月16日
  setWEIGHT({ commit }, payload) {
    commit("setWEIGHT", payload);
  },
  setELECTROCARDIOGRAPHY({ commit }, payload) {
    commit("setELECTROCARDIOGRAPHY", payload);
  },
  setSPUTUM_EXAMINATION({ commit }, payload) {
    commit("setSPUTUM_EXAMINATION", payload);
  },
  setHEARING_LOW_LEFT({ commit }, payload) {
    commit("setHEARING_LOW_LEFT", payload);
  },
  setHEARING_LOW_RIGHT({ commit }, payload) {
    commit("setHEARING_LOW_RIGHT", payload);
  },
  setHEARING_HIGH_LEFT({ commit }, payload) {
    commit("setHEARING_HIGH_LEFT", payload);
  },
  setHEARING_HIGH_RIGHT({ commit }, payload) {
    commit("setHEARING_HIGH_RIGHT", payload);
  },
  setWITHOUT_GLASSES_LEFT({ commit }, payload) {
    commit("setWITHOUT_GLASSES_LEFT", payload);
  },
  setWITHOUT_GLASSES_RIGHT({ commit }, payload) {
    commit("setWITHOUT_GLASSES_RIGHT", payload);
  },
  setWITH_GLASSES_LEFT({ commit }, payload) {
    commit("setWITH_GLASSES_LEFT", payload);
  },
  setWITH_GLASSES_RIGHT({ commit }, payload) {
    commit("setWITH_GLASSES_RIGHT", payload);
  },
  setHBA1C({ commit }, payload) {
    commit("setHBA1C", payload);
  },
  setWHITE_BLC({ commit }, payload) {
    commit("setWHITE_BLC", payload);
  },
  setRED_BLC({ commit }, payload) {
    commit("setRED_BLC", payload);
  },
  setPLT_CNT({ commit }, payload) {
    commit("setPLT_CNT", payload);
  },
  setHEMATOCRIT({ commit }, payload) {
    commit("setHEMATOCRIT", payload);
  },
  setURIC_ACID({ commit }, payload) {
    commit("setURIC_ACID", payload);
  },
  setURIC_SUGAR({ commit }, payload) {
    commit("setURIC_SUGAR", payload);
  },
};

const getters = {
  getNAME: (state) => {
    return state.karteData.name;
  },
  // 血圧ここから
  getBP_HIGH: (state) => {
    return state.karteData.features[0].BLOOD_PRESSURE.BP_HIGH;
  },
  getBP_LWST: (state) => {
    return state.karteData.features[0].BLOOD_PRESSURE.BP_LWST;
  },

  getBloodPressure: (state, key) => {
    return state.karteData.features[0].BLOOD_PRESSURE[key];
  },
  // 血圧ここまで

  // 血液検査
  getBLDS: (state) => {
    return state.karteData.features[0].BLOOD_TEST.BLDS;
  },
  getCREATININE: (state) => {
    return state.karteData.features[0].BLOOD_TEST.CREATININE;
  },
  getGAMMA_GTP: (state) => {
    return state.karteData.features[0].BLOOD_TEST.GAMMA_GTP;
  },
  getHDL_CHOLE: (state) => {
    return state.karteData.features[0].BLOOD_TEST.HDL_CHOLE;
  },
  getHMG: (state) => {
    return state.karteData.features[0].BLOOD_TEST.HMG;
  },
  getLDL_CHOLE: (state) => {
    return state.karteData.features[0].BLOOD_TEST.LDL_CHOLE;
  },
  getSGOT_AST: (state) => {
    return state.karteData.features[0].BLOOD_TEST.SGOT_AST;
  },
  getSGPT_ALT: (state) => {
    return state.karteData.features[0].BLOOD_TEST.SGPT_ALT;
  },
  getTOT_CHOLE: (state) => {
    return state.karteData.features[0].BLOOD_TEST.TOT_CHOLE;
  },
  getTRIGLYCERIDE: (state) => {
    return state.karteData.features[0].BLOOD_TEST.TRIGLYCERIDE;
  },
  getHBA1C: (state) => {
    return state.karteData.features[0].BLOOD_TEST.HBA1C;
  },
  getWHITE_BLC: (state) => {
    return state.karteData.features[0].BLOOD_TEST.WHITE_BLC;
  },
  getRED_BLC: (state) => {
    return state.karteData.features[0].BLOOD_TEST.RED_BLC;
  },
  getPLT_CNT: (state) => {
    return state.karteData.features[0].BLOOD_TEST.PLT_CNT;
  },
  getHEMATOCRIT: (state) => {
    return state.karteData.features[0].BLOOD_TEST.HEMATOCRIT;
  },
  getBloodTest: (state, key) => {
    return state.karteData.features[0].BLOOD_TEST[key];
  },

  // 飲酒習慣
  getDRNK_HABIT_RSPS_CD: (state) => {
    return state.karteData.features[0].DRINK.DRNK_HABIT_RSPS_CD;
  },
  getTM1_DRKQTY_RSPS_CD: (state) => {
    return state.karteData.features[0].DRINK.TM1_DRKQTY_RSPS_CD;
  },
  getDRNK_QTY_WEK_CD: (state) => {
    return state.karteData.features[0].DRINK.DRNK_QTY_WEK_CD;
  },
  getDrink: (state, key) => {
    return state.karteData.features[0].DRINK[key];
  },

  // 運動習慣
  getMOV20_WEK_FREQ_ID: (state) => {
    return state.karteData.features[0].EXERCISE.MOV20_WEK_FREQ_ID;
  },
  getMOV30_WEK_FREQ_ID: (state) => {
    return state.karteData.features[0].EXERCISE.MOV30_WEK_FREQ_ID;
  },
  getWLK30_WEK_FREQ_ID: (state) => {
    return state.karteData.features[0].EXERCISE.WLK30_WEK_FREQ_ID;
  },
  getExercise: (state, key) => {
    return state.karteData.features[0].EXERCISE[key];
  },

  // 家族の病歴
  getFMLY_APOP_PATIEN_YN: (state) => {
    return state.karteData.features[0].FAMILY_HISTORY.FMLY_APOP_PATIEN_YN;
  },
  getFMLY_CANCER_PATIEN_YN: (state) => {
    return state.karteData.features[0].FAMILY_HISTORY.FMLY_CANCER_PATIEN_YN;
  },
  getFMLY_DIABML_PATIEN_YN: (state) => {
    return state.karteData.features[0].FAMILY_HISTORY.FMLY_DIABML_PATIEN_YN;
  },
  getFMLY_HDISE_PATIEN_YN: (state) => {
    return state.karteData.features[0].FAMILY_HISTORY.FMLY_HDISE_PATIEN_YN;
  },
  getFMLY_HPRTS_PATIEN_YN: (state) => {
    return state.karteData.features[0].FAMILY_HISTORY.FMLY_HPRTS_PATIEN_YN;
  },
  getFamilyHistory: (state, key) => {
    return state.karteData.features[0].FAMILY_HISTORY[key];
  },

  // 一般
  getAGE: (state) => {
    return state.karteData.features[0].GENERAL.AGE;
  },
  getDFAB_PTN_CD: (state) => {
    return state.karteData.features[0].GENERAL.DFAB_PTN_CD;
  },
  getSEX: (state) => {
    return state.karteData.features[0].GENERAL.SEX;
  },
  getT: (state) => {
    return state.karteData.features[0].GENERAL.T;
  },
  getGeneral: (state, key) => {
    return state.karteData.features[0].GENERAL[key];
  },

  // 肥満度
  getBMI: (state) => {
    return state.karteData.features[0].MEASURE.BMI;
  },
  getWAIST: (state) => {
    return state.karteData.features[0].MEASURE.WAIST;
  },
  // 新規追加項目 健康診断項目 ↓ 12月16日
  getWEIGHT: (state) => {
    return state.karteData.features[0].MEASURE.WEIGHT;
  },
  getELECTROCARDIOGRAPHY: (state) => {
    return state.karteData.features[0].MEASURE.ELECTROCARDIOGRAPHY;
  },
  getSPUTUM_EXAMINATION: (state) => {
    return state.karteData.features[0].MEASURE.SPUTUM_EXAMINATION;
  },
  getHEARING_LOW_LEFT: (state) => {
    return state.karteData.features[0].MEASURE.HEARING_LOW_LEFT;
  },
  getHEARING_LOW_RIGHT: (state) => {
    return state.karteData.features[0].MEASURE.HEARING_LOW_RIGHT;
  },
  getHEARING_HIGH_LEFT: (state) => {
    return state.karteData.features[0].MEASURE.HEARING_HIGH_LEFT;
  },
  getHEARING_HIGH_RIGHT: (state) => {
    return state.karteData.features[0].MEASURE.HEARING_HIGH_RIGHT;
  },
  getWITHOUT_GLASSES_LEFT: (state) => {
    return state.karteData.features[0].MEASURE.WITHOUT_GLASSES_LEFT;
  },
  getWITHOUT_GLASSES_RIGHT: (state) => {
    return state.karteData.features[0].MEASURE.WITHOUT_GLASSES_RIGHT;
  },
  getWITH_GLASSES_LEFT: (state) => {
    return state.karteData.features[0].MEASURE.WITH_GLASSES_LEFT;
  },
  getWITH_GLASSES_RIGHT: (state) => {
    return state.karteData.features[0].MEASURE.WITH_GLASSES_RIGHT;
  },
  getMeasure: (state, key) => {
    return state.karteData.features[0].MEASURE[key];
  },

  // 喫煙習慣
  getSMK_STAT_TYPE_RSPS_CD: (state) => {
    return state.karteData.features[0].SMOKE.SMK_STAT_TYPE_RSPS_CD;
  },
  getPAST_DSQTY_RSPS_CD: (state) => {
    return state.karteData.features[0].SMOKE.PAST_DSQTY_RSPS_CD;
  },
  getPAST_SMK_TERM_RSPS_CD: (state) => {
    return state.karteData.features[0].SMOKE.PAST_SMK_TERM_RSPS_CD;
  },
  getCUR_DSQTY_RSPS_CD: (state) => {
    return state.karteData.features[0].SMOKE.CUR_DSQTY_RSPS_CD;
  },
  getCUR_SMK_TERM_RSPS_CD: (state) => {
    return state.karteData.features[0].SMOKE.CUR_SMK_TERM_RSPS_CD;
  },
  getSmoke: (state, key) => {
    return state.karteData.features[0].SMOKE[key];
  },
  // 尿検査
  getOLIG_PROTE_CD: (state) => {
    return state.karteData.features[0].URINE_TEST.OLIG_PROTE_CD;
  },
  getURIC_SUGAR: (state) => {
    return state.karteData.features[0].URINE_TEST.URIC_SUGAR;
  },
  getURIC_ACID: (state) => {
    return state.karteData.features[0].URINE_TEST.URIC_ACID;
  },
  getUrineTest: (state, key) => {
    return state.karteData.features[0].URINE_TEST[key];
  },

  // 病歴
  getHCHK_APOP_PMH_YN: (state) => {
    return state.karteData.features[0].PAST_HISTORY.HCHK_APOP_PMH_YN;
  },
  getHCHK_DIABML_PMH_YN: (state) => {
    return state.karteData.features[0].PAST_HISTORY.HCHK_DIABML_PMH_YN;
  },
  getHCHK_ETCDSE_PMH_YN: (state) => {
    return state.karteData.features[0].PAST_HISTORY.HCHK_ETCDSE_PMH_YN;
  },
  getHCHK_HDISE_PMH_YN: (state) => {
    return state.karteData.features[0].PAST_HISTORY.HCHK_HDISE_PMH_YN;
  },
  getHCHK_HPLPDM_PMH_YN: (state) => {
    return state.karteData.features[0].PAST_HISTORY.HCHK_HPLPDM_PMH_YN;
  },
  getHCHK_HPRTS_PMH_YN: (state) => {
    return state.karteData.features[0].PAST_HISTORY.HCHK_HPRTS_PMH_YN;
  },
  getHCHK_PHSS_PMH_YN: (state) => {
    return state.karteData.features[0].PAST_HISTORY.HCHK_PHSS_PMH_YN;
  },
  getPastHistory: (state, key) => {
    return state.karteData.features[0].PAST_HISTORY[key];
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
